export const useHeading = ({ data, customTitle, customDescription, searchValue, categoryFilterTerm, getLabel }) => {
	if (searchValue) {
		return {
			headingTitle: getLabel('search_title'),
			headingDescription: getLabel('search_desc'),
		};
	} else if (!['all', 'staff_pick'].includes(categoryFilterTerm)) {
		return {
			headingTitle: data?.categories[categoryFilterTerm]?.title,
			headingDescription: data?.categories[categoryFilterTerm]?.desc,
		};
	} else {
		return {
			headingTitle: customTitle ? customTitle : getLabel('all_features_title'),
			headingDescription: customDescription ? customDescription : getLabel('all_features_desc'),
		};
	}
};
